import { Injectable, signal } from "@angular/core";
import { UserRole } from "@shared/models";

@Injectable({
    providedIn:'root'
})
export class RoleChangeTestAPIStore{
    private readonly _roleChanged=signal<boolean>(false);
    private readonly _role=signal<UserRole|null>(null);

    readonly roleChanged=this._roleChanged.asReadonly();
    readonly role=this._role.asReadonly();


    setRoleChange(changed:boolean){
        this._roleChanged.set(changed);
    }

    setRole(role:UserRole){
        this._role.set(role);
    }
}